import { INK, RO, Z } from "../theme3d";
import { usePanelOccluded } from "./PanelOcclusionContext";

export interface PanelRuleProps {
  length: number;
  thickness?: number;
  color?: string;
  opacity?: number;
  orientation?: "h" | "v";
  position?: [number, number, number];
  // Defaults to the enclosing ShojiBacking's `occluded` (via context) —
  // same as PanelText. Pass explicitly only to override.
  occluded?: boolean;
}

// A thin accent line — the amber rule under a kicker, or the vertical rule
// that (alongside family + color) tells the Seiji/instruction voices apart
// without needing an italic variant of Zen Old Mincho (which doesn't
// exist; see PanelText.tsx's font tiers and fonts.ts's coverage notes).
export function PanelRule({
  length,
  thickness = 0.006,
  color = INK.accent,
  opacity = 0.7,
  orientation = "h",
  position = [0, 0, 0],
  occluded,
}: PanelRuleProps) {
  const resolvedOccluded = usePanelOccluded(occluded);
  const size: [number, number] = orientation === "h" ? [length, thickness] : [thickness, length];
  const [x, y, z] = position;

  return (
    <mesh
      position={[x, y, z + Z.rule]}
      renderOrder={resolvedOccluded ? RO.panelRule : RO.overlayBacking + 1}
    >
      <planeGeometry args={size} />
      <meshBasicMaterial
        color={color}
        transparent
        opacity={opacity}
        depthTest={resolvedOccluded}
        depthWrite={false}
      />
    </mesh>
  );
}
